import React from 'react';

const ThermometerIcon = ({ width = 24, height = 24, color = '#0F7F85' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M10 20L8.75 17.5L6 18M10 4L8.75 6.5L6 6M10.585 15H10M2 12H8.5L10 9M20 14.54C20.7626 14.9803 21.3586 15.6599 21.6955 16.4734C22.0325 17.2869 22.0916 18.1888 21.8637 19.0394C21.6358 19.8899 21.1336 20.6415 20.435 21.1775C19.7365 21.7136 18.8805 22.0041 18 22.0041C17.1195 22.0041 16.2635 21.7136 15.565 21.1775C14.8664 20.6415 14.3642 19.8899 14.1363 19.0394C13.9084 18.1888 13.9675 17.2869 14.3045 16.4734C14.6414 15.6599 15.2374 14.9803 16 14.54V4C16 3.46957 16.2107 2.96086 16.5858 2.58579C16.9609 2.21071 17.4696 2 18 2C18.5304 2 19.0391 2.21071 19.4142 2.58579C19.7893 2.96086 20 3.46957 20 4V14.54Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10L5.5 12L4 14M7 21L10 15L8.5 12M7 3L10 9H12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ThermometerIcon;
